query Workspaces($search: String!) {
  allWorkspaces(search: $search) {
    id
    name
  }
}
